import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票信息")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }

import { ref, watch } from 'vue';
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import {
  BasicInformationData
  // MakeOutAnInvoiceParams
} from '@V/invoice/src/data-source/types';

type BaseInfo = BasicInformationData['baseInfo'];


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-open-dialog-info',
  props: {
    baseInfo: {},
    disabled: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const formRef = ref(null);
// const formData = defineModel<MakeOutAnInvoiceParams>();
const info = ref<BaseInfo>({
  entpName: '',
  entpCertNo: '',
  phone: '',
  bankName: '',
  openBankNumber: '',
  companyBusinessAddress: '',
  demand: ''
});
const infoRules = {
  entpName: [{ required: true, message: '', trigger: 'blur' }],
  entpCertNo: [{ required: true, message: '', trigger: 'blur' }],
  phone: [{ required: true, message: '', trigger: 'blur' }],
  bankName: [{ required: true, message: '', trigger: 'blur' }],
  openBankNumber: [{ required: true, message: '', trigger: 'blur' }],
  companyBusinessAddress: [{ required: true, message: '', trigger: 'blur' }]
};
watch(
  () => props.baseInfo,
  v => {
    info.value = v;
  }
);

__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    model: info.value,
    rules: infoRules
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "企业名称",
          prop: "entpName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: _ctx.baseInfo.entpName
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "纳税识别号",
          prop: "entpCertNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: _ctx.baseInfo.entpCertNo
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "联系电话",
          prop: "phone"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "tel",
              placeholder: "请输入",
              disabled: "",
              modelValue: _ctx.baseInfo.phone
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "开户银行",
          prop: "bankName"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: _ctx.baseInfo.bankName
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "银行账号",
          prop: "openBankNumber"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: _ctx.baseInfo.openBankNumber
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(BaseFormItem), {
          label: "企业地址",
          prop: "companyBusinessAddress"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "text",
              placeholder: "请输入",
              disabled: "",
              modelValue: _ctx.baseInfo.companyBusinessAddress
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})